import BlankView from '@/components/BlankView.vue'
const maintainManagement = [
      {
        path: 'maintainManagement',
        name: '数据维护',
        component: BlankView,
        children:[
           //收货地管理
          {
            path: 'placeofReceiptManagement',
            name: 'placeofReceiptManagement',
            component: () => import('@/views/maintainManagement/placeofReceiptManagement.vue'),
          },
          //发货地管理
          {
            path: 'placeofShipmentManagement',
            name: 'placeofShipmentManagement',
            component: () => import('@/views/maintainManagement/placeofShipmentManagement.vue'),
          },
          //品名管理
          {
            path: 'goodsNameManagement',
            name: 'goodsNameManagement',
            component: () => import('@/views/maintainManagement/goodsNameManagement.vue'),
          }
        ]
      }
    
];


export default maintainManagement;